import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import CategorySection from 'components/section/CategorySection';
import Title from 'components/ui/Title';
import { getCategories } from 'store/category';
import { getAssets } from 'store/asset';
import AssetCard from 'components/cards/AssetCard';
import { available } from 'config/asset';

const Homepage = () => {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const { list: assets } = useSelector(state => state.asset);

  const [category, setCategory] = useState(false);
  const [loading, setLoading] = useState(true);

  const fetchData = () => {
    Promise.all([
      dispatch(getCategories()),
      dispatch(getAssets())
    ])
      .then(() => {
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }

  useEffect(() => {
    fetchData()
  }, [])

  if (loading || !assets) {
    return (
      <div className="px-8 flex flex-col gap-8 h-full overflow-y-scroll pb-6 animate-pulse">
        <div className="h-6 bg-gray-300 rounded w-1/3" />
        <div className="h-14 bg-gray-300 rounded w-2/3" />
        <div className="h-6 bg-gray-300 rounded w-1/3" />
        <div className="h-14 bg-gray-300 rounded w-2/3" />
        <div className="h-6 bg-gray-300 rounded w-1/3" />
        <div className="h-14 bg-gray-300 rounded w-2/3" />
        <div className="h-6 bg-gray-300 rounded w-1/3" />
        <div className="h-14 bg-gray-300 rounded w-2/3" />
      </div>
    );
  }

  return (
    <div className="flex flex-col h-full w-full gap-8">
      <div className="flex flex-col gap-5 px-8">
        <Title text={t('category.label', { count: 2 })} />
        <CategorySection onChange={setCategory} />
      </div>
      <div className="flex flex-col gap-5">
        <div className="px-8">
          <Title text={t('asset.available')} url="/assets" />
        </div>
        <div className="pl-8 w-full">
          <div className="flex gap-5 overflow-x-auto pb-4 snap-x scrollbar-hide">
            {assets && assets.filter(el => available.includes(el.state) && el.enabled).length > 0
              ?
              assets.filter(el =>
                available.includes(el.state) &&
                el.enabled &&
                (!category || category === el.category.id)
              ).map((item, index) => (
                <div key={index} className="snap-start">
                  <AssetCard asset={item} className="min-w-[160px] max-w-[160px]" />
                </div>
              ))
              :
              <span>
                {t('asset.no_available')}
              </span>
            }
          </div>
        </div>
      </div>
      <div className="flex flex-col gap-5">
        <div className="px-8">
          <Title text={t('asset.all')} url="/assets" />
        </div>
        <div className="pl-8 w-full">
          <div className="flex gap-5 overflow-x-auto pb-4 snap-x scrollbar-hide">
            {assets && assets.length > 0
              ?
              assets.filter(el => !category || category === el.category.id).map((item, index) =>
                <div key={index} className="snap-start">
                  <AssetCard asset={item} className="min-w-[160px] max-w-[160px]" />
                </div>
              )
              :
              <span>
                {t('asset.no_available')}
              </span>}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Homepage;
